module.exports = __webpack_public_path__ + "static/media/cbs-tv-menu-mid.fd5879de.png";